import React from 'react';

import { themeStyle } from '@repo/ui/theming';

import { ContentWrapperStyle, NarrowContent } from './styles';

const getBackground = (key) => {
  switch (key) {
    case 'white':
      return themeStyle.transparent;
    case 'offWhite':
      return themeStyle.varInkLight;
    case 'whiteToOffWhite':
      return `linear-gradient(180deg, ${themeStyle.transparent}  0%, ${themeStyle.transparent}  50%, ${themeStyle.varInkLight}  50%, ${themeStyle.varInkLight}  100%)`;
    case 'offWhiteToWhite':
      return `linear-gradient(180deg, ${themeStyle.varInkLight}  0%, ${themeStyle.varInkLight}  50%, ${themeStyle.transparent}  50%, ${themeStyle.transparent}  100%)`;
    default:
      return key || themeStyle.transparent;
  }
};

/**
 * ContentWrapper component to easily use the ContentWrapper style for individual
 * slices in prismic
 */
const ContentWrapper = (props) => {
  const background = getBackground(
    props.background || props.slice?.primary.background
  );

  if (props.customWidth) {
    return (
      <ContentWrapperStyle background={background} className={props.className}>
        <NarrowContent
          customWidth={props.customWidth}
          forceDarkModeContent={props.forceDarkModeContent}
        >
          {props.children}
        </NarrowContent>
      </ContentWrapperStyle>
    );
  }

  return (
    <ContentWrapperStyle background={background} className={props.className}>
      {props.children}
    </ContentWrapperStyle>
  );
};

export default ContentWrapper;
